'use strict'

var now = require('./now')

/**
 * Replacement for PerformanceTiming.navigationStart for the case when
 * performance.now is not implemented.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming.navigationStart
 *
 * @type {Number}
 * @api private
 */
exports.navigationStart = now()



//////////////////
// WEBPACK FOOTER
// ../node_modules/animation-frame/lib/performance-timing.js
// module id = 14
// module chunks = 0